<template
  ><div style="padding-top:-2px;margin-top:-2px;">
    <v-label
      ><b>{{ label }}</b></v-label
    >
    <s-select-generic
      autocomplete
      class="text"
      itemvalue="FagID"
      :disabled="disabled"
      :value="value"
      id="FagID" itemtext="FagName"
      :return-object="returnObject"
      @input="input($event)"
      @change="change($event)"
      :config="config"
      :full="full"
      :text="text"
      :clearable="clearable"
      :noDefault="noDefault"
    >
    </s-select-generic>
  </div>
</template>

<script>
import _sService from "@/services/Technicalassistance/HarvestSchedule.js";
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    value: null,
    text: { type: String, default: "" },
    label: {
      type: String,
      default: "",
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    producerID: {
      type: Number,
      default: 0,
    },
    noDefault: {
      type: Boolean,
      default: false,
    },    
    full: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(value) {
      this.item = value;
    },
    'producerID' (){
        if(this.producerID != null){
            this.config.params.PrdID=this.producerID
        }else{
          this.config.params.PrdID= 0;
        }
        
    }
  },
  methods: {
    input(val) {
      this.$emit("input", val);
    },
    change(item)
    {
      this.$emit('change', item);
    }
    
  },
  data: () => ({
    item: 0,
    val: "",
    items: [],
    config: {},
  }),

  created() {
    this.config = {
      url: _sService.GetUrllistAgriculturalFarm(),
      title: this.label,
      params: { search: "", requestID: this.$fun.getUserID() , PrdID: 0 },
    };

    console.log(this.config);
  },
};
</script>
